import request from '@/util/http'
import qs from "qs";

//"tab列表"
export function tabsList(query) {
    return request({
        url: query,
        method: 'get',
    })
}



// // 文件list表格
// export function tableList(query) {
//     return request({
//         url: '/admin/policyFiles',
//         method: 'get',
//         params: query
//     })
// }
// 文件list表格
export function tableList(query) {
    return request({
        url: '/admin/tHallPolicyFile/list',
        method: 'get',
        params: query
    })
}

// 全部已读
export const tHallPolicyFileAllRead=(data)=>request({
    url: '/admin/tHallPolicyFile/allRead',
    method: 'post',
    data:qs.stringify(data)
})

// 文件查看权限
export function jurisdiction(id) {
    return request({
        url: `/admin/policyFiles/${id}/acls?tree`,
        method: 'get',
    })
}


export function aclsEdit(id) {
    return request({
        url:`/admin/policyFiles/${id}/acls`,
        method: 'get',
    })
}
export function aclsSaveEdit(query,id) {
    return request({
        url:`/admin/policyFiles/${id}/acls`,
        method: 'put',
        data: query
    })
}

// export function delList(id) {
//     return request({
//         url: 'admin/policyFiles/' + id,
//         method: 'delete',
//         // params: query
//     })
// }
export function delList(data) {
    return request({
        url: 'admin/tHallPolicyFile/delete',
        method: 'post',
        data: data
    })
}
// 上传文件保存
export function saveFile(obj,path) {
    return request({
        url: `/admin/policyFiles`,
        method: 'post',
        data: obj
    })
}
// 文件list表格
export function editFile(query) {
    return request({
        url: '/admin/policyFiles/'+query.id,
        method: 'PUT',
        data: query
    })
}

export function uploadFile(name,path) {
    return request({
        url:`/admin/files/upload/policyFiles?originalFileName=${name}`,
        method: 'get',
    })
}

export function downFile(id) {
    return request({
        url:`/admin/files/download/policyFiles/${id}`,
        method: 'get',
    })
}
export function tableListS(query) {
    return request({
        url: '/admin/studentPolicyFiles',
        method: 'get',
        params: query
    })
}
// 删除校内公文
export function tHallPolicyFileDelete(data) {
    return request({
        url: '/admin/tHallPolicyFile/delete'+'?ids='+data,
        method: 'post',
        // data: data
    })
}
// 添加校内公文
export function tHallPolicyFileSave(data) {
    return request({
        url: '/admin/tHallPolicyFile/save',
        method: 'post',
        data: data
    })
}
// 修改校内公文
export function tHallPolicyFileUpdate(data) {
    return request({
        url: '/admin/tHallPolicyFile/update',
        method: 'post',
        data: data
    })
}
// 通过id查校内公文
export function tHallPolicyFileId(id,fileId) {
    return request({
        url: `/admin/tHallPolicyFile/${id}`,
        method: 'get',
    })
}
// 下载文件
export function fileDownload(id) {
    return request({
        url: `/admin/file/download/${id}`,
        method: 'post',
    })
}
// 获取通知信息
export function getNoticeList(params) {
    return request({
        url: `/admin/homeTemplate/getNoticeList`,
        method: 'get',
        params: params
    })
}

